import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllCurrencies } from '../api/currencyApi';

// TODO: define state
interface Currency {
  id: string | number;
  [key: string]: any;
}

type CurrenciesState = Currency[] | null;

export const fetchCurrencies = createAsyncThunk<Currency[], void>(
  'currencies/fetchCurrencies',
  async (_, { dispatch }) => {
    const currencies = await getAllCurrencies();
    dispatch(loadCurrencies(currencies));
    return currencies;
  }
);

const currenciesSlice = createSlice({
  name: 'currencies',
  initialState: null as CurrenciesState,
  reducers: {
    loadCurrencies: (state, action: PayloadAction<Currency[]>) => {
      return action.payload;
    },
    updateCurrency: (state, action: PayloadAction<Currency>) => {
      if (state === null) return state;

      return state.map((currency) =>
        currency.id === action.payload.id ? action.payload : currency
      );
    },
    createCurrency: (state, action: PayloadAction<Currency>) => {
      if (state === null) return state;

      return [...state, action.payload];
    },
    deleteCurrency: (state, action: PayloadAction<string | number>) => {
      if (state === null) return state;

      return state.filter((currency) => currency.id !== action.payload);
    },
  },
});

export const {
  loadCurrencies,
  updateCurrency,
  createCurrency,
  deleteCurrency,
} = currenciesSlice.actions;

export default currenciesSlice.reducer;
